<!-- Floating Pill Launcher Widget (Matching Screenshot 1) -->
<div class="floating-ria-launcher" *ngIf="!isOpen" (click)="toggleChat()" role="button" aria-label="Open Ask Mily Live Chat">
  <div class="launcher-avatar-wrap">
    <img src="/assets/images/ria-avatar.png" alt="Ask Mily" class="launcher-avatar-img" />
    <span class="launcher-status-dot"></span>
  </div>
  <div class="launcher-pill-body">
    <span class="launcher-title">ASK Mily</span>
    <span class="launcher-subtitle">LIVE CHAT</span>
  </div>
</div>

<!-- Chat Bot Window Modal / Widget (Matching Screenshot 2) -->
<div class="chat-widget-box" *ngIf="isOpen" role="dialog" aria-label="Ask Mily Live Chat">
  
  <!-- Widget Header -->
  <div class="chat-widget-header">
    <div class="header-avatar-wrap">
      <img src="/assets/images/ria-avatar.png" alt="Mily Avatar" class="header-avatar-img" />
      <span class="header-online-dot"></span>
    </div>
    
    <div class="header-info">
      <h3 class="header-title">Ask Mily</h3>
      <p class="header-subtitle">Your Service Champion &bull; Online</p>
    </div>

    <div class="header-actions">
      <button type="button" class="header-btn" (click)="restart()" title="Restart Conversation">
        <span class="material-symbols-outlined text-[20px]">restart_alt</span>
      </button>
      <button type="button" class="header-btn" (click)="toggleChat()" title="Close / Minimize">
        <span class="material-symbols-outlined text-[20px]">close</span>
      </button>
    </div>
  </div>

  <!-- Chat Body: Messages Stream -->
  <div class="chat-widget-body" #chatScroll>
    
    <!-- Time stamp divider -->
    <div class="chat-time-divider">
      <span>Today</span>
    </div>

    <!-- Messages -->
    <div *ngFor="let msg of messages" class="chat-message-row" [class.user-row]="msg.author === 'user'">
      
      <!-- Assistant Avatar -->
      <div class="msg-avatar-col" *ngIf="msg.author === 'assistant'">
        <img src="/assets/images/ria-avatar.png" alt="Mily" class="msg-avatar-img" />
      </div>

      <!-- Bubble & Embedded Content -->
      <div class="msg-bubble-wrap">
        
        <!-- Text Bubble -->
        <div class="msg-bubble" [class.user-bubble]="msg.author === 'user'">
          <p class="bubble-text">{{ msg.text }}</p>
        </div>
        <span class="msg-time">{{ msg.time }}</span>

        <!-- 1. Service Menu Stack (Screenshot 2 Buttons) -->
        <div class="service-menu-stack" *ngIf="msg.type === 'menu'">
          <button type="button"
            *ngFor="let opt of menuOptions"
            (click)="handleMenuClick(opt.id)"
            class="menu-action-btn">
            <span class="material-symbols-outlined menu-btn-icon">{{ opt.icon }}</span>
            <span class="menu-btn-label">{{ opt.title }}</span>
          </button>
        </div>

        <!-- 2. Departments Choice Grid -->
        <div class="departments-chip-grid" *ngIf="msg.type === 'branches'">
          <button type="button"
            *ngFor="let branch of msg.data"
            (click)="chooseBranch(branch)"
            class="dept-chip-btn">
            <span class="material-symbols-outlined text-[16px]">location_on</span>
            <span>{{ branch.name }}</span>
          </button>
        </div>

        <!-- 3. Departments Choice Grid -->
        <div class="departments-chip-grid" *ngIf="msg.type === 'departments'">
          <button type="button"
            *ngFor="let dept of departments"
            (click)="chooseDepartment(dept)"
            class="dept-chip-btn">
            <span class="material-symbols-outlined text-[16px]">local_hospital</span>
            <span>{{ dept.title }}</span>
          </button>
        </div>

        <!-- 4. Doctor Cards in Chat -->
        <div class="doctors-cards-stack" *ngIf="msg.type === 'doctors'">
          <div class="chat-doctor-card" *ngFor="let doc of msg.data">
            <div class="chat-doc-avatar">
              <img [src]="doc.image !== 'https://medeaseadmin.onetikk.org/storage/' ? doc.image : '/assets/images/icons/doctor-default-img.png'" [alt]="doc.title" />
            </div>
            <div class="chat-doc-info">
              <div class="chat-doc-badge">{{ doc.specialty }}</div>
              <h4 class="chat-doc-name">Dr. {{ doc.title }}</h4>
              <p class="chat-doc-desig">{{ doc.designation || 'Specialist Physician' }}</p>
            </div>
            <button type="button" class="chat-doc-select-btn" (click)="chooseDoctor(doc)">
              <span>Select</span>
              <span class="material-symbols-outlined text-[16px]">arrow_forward</span>
            </button>
          </div>
        </div>

        <!-- 4. Patient Form Inside Chat -->
        <div class="chat-form-card" *ngIf="msg.type === 'patient_form'">
          <form [formGroup]="patientForm" (ngSubmit)="submitPatientDetails()">
            <div class="form-group mb-2">
              <label class="form-label">Patient Full Name</label>
              <input type="text" formControlName="name" class="form-input" placeholder="e.g. John Doe" />
              <span class="text-xs text-red-500" *ngIf="patientForm.get('name')?.touched && patientForm.get('name')?.invalid">Valid name required (min 3 chars).</span>
            </div>

            <div class="grid grid-cols-2 gap-2 mb-2">
              <div class="form-group">
                <label class="form-label">Gender</label>
                <select formControlName="gender" class="form-input">
                  <option value="">Select</option>
                  <option value="1">Male</option>
                  <option value="0">Female</option>
                  <option value="2">Other</option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">Date of Birth</label>
                <input type="date" formControlName="dob" class="form-input" />
              </div>
            </div>

            <div class="form-group mb-3">
              <label class="form-label">MR Number (Optional)</label>
              <input type="text" formControlName="mrNumber" class="form-input" placeholder="If existing patient" />
            </div>

            <button type="submit" class="form-submit-btn" [disabled]="patientForm.invalid">
              <span>Confirm Patient & Select Date</span>
              <span class="material-symbols-outlined text-[16px]">arrow_forward</span>
            </button>
          </form>
        </div>

        <!-- 5. Date Selection Pills -->
        <div class="dates-chip-scroll" *ngIf="msg.type === 'dates'">
          <button type="button"
            *ngFor="let dt of msg.data"
            (click)="chooseDate(dt)"
            class="date-chip-btn">
            <span class="material-symbols-outlined text-[15px]">calendar_today</span>
            <span>{{ dt | date:'EEE, MMM d' }}</span>
          </button>
        </div>

        <!-- 6. Time Slot Pills -->
        <div class="slots-chip-grid" *ngIf="msg.type === 'slots'">
          <button type="button"
            *ngFor="let s of msg.data"
            (click)="chooseSlot(s)"
            class="slot-chip-btn">
            <span class="material-symbols-outlined text-[14px]">schedule</span>
            <span>{{ s.start_time | date:'h:mm a' }}</span>
          </button>
        </div>

        <!-- 7. Booking Confirmation Summary Card -->
        <div class="confirmation-summary-card" *ngIf="msg.type === 'confirmation'">
          <div class="summary-header">
            <span class="material-symbols-outlined text-[#10b981] text-[24px]">verified</span>
            <h4>Ready to Secure Your Slot</h4>
          </div>

          <div class="summary-details">
            <div class="summary-row">
              <span class="row-label">Doctor</span>
              <span class="row-val font-bold">Dr. {{ msg.data.doctor?.title }}</span>
            </div>
            <div class="summary-row">
              <span class="row-label">Specialty</span>
              <span class="row-val">{{ msg.data.doctor?.specialty }}</span>
            </div>
            <div class="summary-row">
              <span class="row-label">Date</span>
              <span class="row-val font-semibold">{{ msg.data.date | date:'fullDate' }}</span>
            </div>
            <div class="summary-row">
              <span class="row-label">Time</span>
              <span class="row-val font-bold text-[#112c76]">{{ msg.data.slot?.start_time | date:'h:mm a' }}</span>
            </div>
            <div class="summary-row">
              <span class="row-label">Patient</span>
              <span class="row-val">{{ msg.data.patient?.name }}</span>
            </div>
          </div>

          <button type="button" class="confirm-book-btn" (click)="continueToBooking()" [disabled]="isSubmittingBooking">
            <span>{{ isSubmittingBooking ? 'Opening secure payment...' : 'Proceed to Secure Booking' }}</span>
            <span class="material-symbols-outlined text-[18px]">lock</span>
          </button>
        </div>

      </div>
    </div>

    <!-- Typing Indicator Animation -->
    <div class="typing-indicator-row" *ngIf="isTyping">
      <div class="msg-avatar-col">
        <img src="/assets/images/ria-avatar.png" alt="Mily" class="msg-avatar-img" />
      </div>
      <div class="typing-bubble">
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
      </div>
    </div>

  </div>

  <!-- Quick Suggestion Chips Bar -->
  <div class="chat-quick-chips">
    <button type="button" class="quick-chip" (click)="userInput = 'I need to see a skin doctor tomorrow'; sendMessage()">
      &ldquo;Skin doctor tomorrow&rdquo;
    </button>
    <button type="button" class="quick-chip" (click)="userInput = 'Consult a cardiologist this evening'; sendMessage()">
      &ldquo;Consult cardiologist&rdquo;
    </button>
    <button type="button" class="quick-chip" (click)="handleMenuClick('bookings')">
      &ldquo;Check my bookings&rdquo;
    </button>
  </div>

  <!-- Footer Input Bar (Matching Screenshot 2) -->
  <div class="chat-widget-footer">
    <!-- Home / Menu Button -->
    <button type="button" class="footer-home-btn" (click)="goToMainMenu()" title="Main Menu">
      <span class="material-symbols-outlined text-[22px]">home</span>
    </button>

    <!-- Text Input -->
    <div class="footer-input-wrap">
      <input type="text"
        [(ngModel)]="userInput"
        (keyup.enter)="sendMessage()"
        class="footer-text-input"
        placeholder="Type your message..."
        [disabled]="isTyping"
        aria-label="Chat with Mily" />
    </div>

    <!-- Send Button -->
    <button type="button"
      class="footer-send-btn"
      (click)="sendMessage()"
      [disabled]="!userInput.trim() || isTyping"
      title="Send message">
      <span class="material-symbols-outlined text-[20px]">send</span>
    </button>
  </div>

</div>
